import { IApiMarkupProfile, IApiMarkupProfileWithStreams } from '@cbridge-packages/api';
import { StreamTranslator } from '@cbridge-packages/stream';
import { IMarkupProfile } from './markupProfile.interface';

export namespace MarkupProfileTranslator {
  export function fromApi(markupProfile: IApiMarkupProfile): IMarkupProfile {
    if (!markupProfile) {
      return undefined;
    }

    return {
      markupProfileId: markupProfile.id,
      markupProfileName: markupProfile.name,
    };
  }
  export function fromApiDetails(markupProfile: IApiMarkupProfileWithStreams): IMarkupProfile {
    const result = MarkupProfileTranslator.fromApi(markupProfile);
    result.streams = markupProfile?.streams?.map(StreamTranslator.fromApiBase);

    return result;
  }

  export function toApi(markupProfile: Partial<IMarkupProfile>): IApiMarkupProfile {
    return {
      id: markupProfile.markupProfileId,
      name: markupProfile.markupProfileName,
    };
  }
}
